import { useEffect } from 'react';
import { notification } from '@pu/mpp-ui/notifications';
import { notificationService } from 'shared/utils/notification.utils';

export const useGlobalNotifications = () => {
  useEffect(() => {
    const notificationHandlers = {
      success: notification.success,
      error: notification.error,
      warning: notification.warning,
      dismiss: notification.dismiss,
      clear: notification.clear,
    } as const;

    const unregister = notificationService.registerGlobalCallback(({ handler, message, options }) => {
      const notificationHandler = notificationHandlers[handler] || notification.success;
      notificationHandler(message || '', options);
    });

    return unregister;
  }, []);
};
